export default __webpack_public_path__ + "static/media/payBreakdownIcon.a95a2c27.svg";